import { css } from '@emotion/react'
import moment from 'moment/moment';
 /** @jsxImportSource @emotion/react */
import React from 'react'
import { useLocation } from 'react-router-dom'

export default function MemberDetail() {
  const location = useLocation();
  // console.log("location.state",location.state)
  const {username,full_name,limit_daily_max_bet_amount_per_user,phone_number,created_at} = location.state;
  return (
    <div>
      {/* <h2 style={{fontWeight: 'normal'}}>Member Detail</h2> */}
      <div  css={css`
            /* background-color: #EEEEEE; */
            border-radius: 1rem;
            padding: 1rem;
            margin: 3rem 10rem 0 10rem;
            box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
        `}>
        <div style={{display: "flex",marginBottom: "1rem"}}>
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: 'grey'}}>Username</h3>
            <h3 style={{fontWeight: "normal"}}>{username}</h3>
          </div>
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: "grey"}}>Phone No.</h3>
            <h3 style={{fontWeight: "normal"}}>{phone_number}</h3>
          </div>
        </div>
        <div style={{display: "flex",marginBottom: "1rem"}}>
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: 'grey'}}>Full Name</h3>
            <h3 style={{fontWeight: "normal"}}>{full_name}</h3>
          </div>
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: "grey"}}>Max Daily Limit</h3>
            <h3 style={{fontWeight: "normal"}}>{limit_daily_max_bet_amount_per_user}</h3>
          </div>
        </div>
        <div style={{display: "flex"}}>
          {/* <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: 'grey'}}>TimeZone</h3>
            <h3 style={{fontWeight: "normal"}}>{timezone}</h3>
          </div> */}
          <div style={{display: "flex",flexDirection: "column",flexBasis: "50%",marginBottom: "1rem"}}>
            <h3 style={{marginBottom: "1rem",color: "grey"}}>Join Date</h3>
            <h3 style={{fontWeight: "normal"}}>{moment(created_at).format('MM-DD-YYYY h:mmA')}</h3>
          </div>
        </div>
      </div>
    </div>
  )
}
